import EmptyState from 'ui/EmptyState';
import Link from 'ui/Link';

type Props = {
  title: string;
};

const ErrorPage: React.FC<Props> = ({ title }) => (
  <EmptyState
    flexGrow={1}
    icon="bug"
    title={title}
    description="Please try refreshing the page or come back later. If the problem persists, feel free to reach out to us."
  >
    <Link href="mailto:support@sankeyart.com">Contact support</Link>
  </EmptyState>
);

export default ErrorPage;
